import classNames from "classnames";
import React, { useCallback, useState } from "react"
import ChevronDownIcon from 'ui/Icons/tabler/chevron-down.component.svg';
import ChevronUpIcon from 'ui/Icons/tabler/chevron-up.component.svg';
import { SvgIcon } from 'ui/SvgIcon';
interface IRateInclusions {
  features: string[];
}
export const RateInclusions: React.FC<IRateInclusions> = ({ features }) => {
  const [rateInclusionsIsOpen, setRateInclusionsIsOpen] = useState(false);
  const handleOpenRateInclusions = useCallback(() => setRateInclusionsIsOpen((preVal) => !preVal),[rateInclusionsIsOpen])
  
  return (
    <div className="mt-[5px] mb-[5px]" onClick={handleOpenRateInclusions}>
      <div className="text-brown-prime font-light mb-[5px] cursor-pointer">
        <span className="underline">Rate Inclusions</span>{' '}
        <SvgIcon
          IconComponent={rateInclusionsIsOpen ? ChevronUpIcon : ChevronDownIcon}
          className="w-3 fill-transparent stroke-current stroke-2 inline"
        />
      </div>
      <div className={`grid transition-[grid-template-rows] duration-300 ml-[10px] ${rateInclusionsIsOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
        <div className="overflow-hidden min-h-0">
          {features.map(f => (<li className="font-hurmegeometric-sans text-flint text-[12px] marker:text-[8px]">{f}.</li>))}
        </div>
      </div>
    </div>
  )

}